import React from 'react';
import LookupItemService from '../Services/LookupItemService';

class LookupItemText extends React.Component {
  static defaultProps = {
    lookupId: 0,
    lookupItemId: 0,
  };

  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
  }

  componentDidMount() {
    this.GetLookup();
  }

  GetLookup() {
    LookupItemService.GetLookupItemById(this.props.lookupItemId)
      .then((item) => {
        // console.log(item);
        this.setState({ text: item ? item.text : '' });
      })
      .catch((error) => this.setState({ text: '' }));
  }

  componentDidUpdate(prevProps) {
    if (this.props.lookupId !== prevProps.lookupId || this.props.lookupItemId !== prevProps.lookupItemId)
      this.GetLookup();
  }

  render() {
    return this.state.text;
  }
}

export default LookupItemText;
